export const TEXTS = {
  MODAL_TITLE: 'Генерация аудиоролика',
  FIELD_TITLE_LABEL: 'Введите название',
  FIELD_TITLE_PLACEHOLDER: 'Например, промо-акция',
  FIELD_TEXT_LABEL: 'Текст для озвучки',
  FIELD_TEXT_PLACEHOLDER: 'Например: Скидка 30% на всю мебель только до пятницы. Успейте купить, количество ограничено',
  FIELD_VOICE_LABEL: 'Голос',
  FIELD_VOICE_PLACEHOLDER: 'Выберите голос озвучки',
  FIELD_BACKGROUND_LABEL: 'Фон',
  FIELD_BACKGROUND_PLACEHOLDER: 'Выберите фон озвучки',
  TEXT_MAX_LENGTH_HINT: (n: number) => `Максимум ${n} символов`,
  AFTER_GENERATE_HINT: 'После генерации вы можете скачать ролики или выбрать нужные для создания рекламной кампании',
  BUTTON_GENERATE: 'Сгенерировать аудиоролик',
  BUTTON_CREATE_CAMPAIGN: 'Создать рекламную кампанию',
  BUTTON_CLOSE: 'Закрыть',
  TEXT_MAX_LENGTH: (n: number) => `Максимум ${n} символов`,
  FIELD_REQUIRED: 'Обязательное поле',
  LIMIT_WARNING: (n: number) => `Доступно ещё ${n} генераций аудиоролика на сегодня`,
  LIMIT_EXHAUSTED: (n: number) => `Вы достигли дневного лимита — ${n} генераций. Завтра он будет обновлён`,
  JOB_STATUS_FAILED: 'Ошибка генерации',
  NOTIFICATION_CREATE_SUCCESS: 'Генерация аудиоролика запущена',
  NOTIFICATION_CREATE_ERROR: 'Не удалось запустить генерацию',
  NOTIFICATION_CREATE_DUPLICATE_COMPLETED: 'Ролик с такими параметрами уже сгенерирован',
  NOTIFICATION_CREATE_DUPLICATE_ACTIVE: 'Ролик с такими параметрами уже создаётся',
  NOTIFICATION_LIMIT_EXCEEDED: 'Достигнут дневной лимит генераций на сегодня',
  NOTIFICATION_DUPLICATE_TITLE_ERROR: 'Ролик с таким названием уже существует',
  NOTIFICATION_DELETE_SUCCESS: 'Аудиоролик удалён',
  NOTIFICATION_DELETE_ERROR: 'Не удалось удалить аудиоролик',
};
